import type { Customer, PaymentMethod } from '@/types/checkout';
import type { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { getEnvVariable } from '@/utils/get-env-variable';

export const getPaypalScriptOptions = (paypalPk: string, currencyCode: string) => {
  if (!paypalPk) {
    console.error('PayPal key is missing');
    return null;
  }

  return {
    clientId: getEnvVariable('VITE_PAYPAL_CLIENT_ID', 'test'),
    dataClientToken: paypalPk,
    disableFunding: 'card,venmo,credit,paylater,bancontact,blik,eps,giropay,ideal,mybank,p24,sepa,sofort,mercadopago',
    enableFunding: 'paypal',
    currency: currencyCode.toUpperCase(),
  };
};

export const getLastFourDigits = (cardNumber: string) => {
  return cardNumber?.slice(-4);
};

export const getBillingDetails = (customer: Customer) => {
  return {
    email: customer.email ?? '',
    address: {
      city: customer.address?.city,
      state: customer.address?.state,
      postal_code: customer.address?.zipCode,
      country: customer.geoLocator?.countryCode2,
    },
  };
};

export const getProviderFromPaymentMethod = (paymentMethod: PaymentMethodEnum, paymentMethods: PaymentMethod[]) => {
  return paymentMethods.find((pm) => pm.paymentMethodName === paymentMethod)?.provider as ProviderEnum;
};
